<div class="modal fade" id="editAddModal-3" tabindex="-1" aria-labelledby="exampleEditModalLabel" aria-hidden="true">
  <div style="max-width: 64rem;" class="modal-dialog modal-dialog-centered modal-lg">
    <form (ngSubmit)="save()"   
      style="border-radius: 20px;" class="modal-content rounded-5 shadow-lg border-0">
      <div class="modal-header border-0 pb-0">
        <h5 style="font-size: 2rem;" class="modal-title fw-semibold" id="exampleEditModalLabel">{{ (isEdit ? "Update" : "Add New") + ' ' + (entityName || selectedTab?.text) }}</h5>
        <button type="button" style="border: none; background: transparent;" data-bs-dismiss="modal" aria-label="Zatvori">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="24" height="24" rx="12" fill="#171717" fill-opacity="0.05"/>
            <rect x="0.5" y="0.5" width="23" height="23" rx="11.5" stroke="#171717" stroke-opacity="0.07"/>
            <path d="M8.375 8.375L15.625 15.625M15.625 8.375L8.375 15.625" stroke="#171717" stroke-width="1.5" stroke-linecap="round"/>
          </svg>
        </button>
      </div>
      <p class="description-text">{{ isEdit ? "Fill out the fields carefully to update this instance, including all necessary information for identification." : "Fill out the fields carefully to create a new instance, including all necessary information for identification." }}</p>
        <div 
          class="new-instance-modal-body modal-body pt-3 m-0 w-100 align-items-center justify-content-between">
          <div class="section w-100 row">
            <ng-container  *ngIf="selectedEquipmentType.value != 'AcLineSegment'">
              <div class="label-div d-flex align-items-center justify-content-left col-6">
                <p>Connector Type</p>
              </div>
              <div class="col-6 mb-3">
                <input
                  class="new-instance-input w-100"
                  type="text"
                  [value]="currentConnectorType?.text"
                  disabled
                />
              </div>
            </ng-container>
            
            <div class="label-div d-flex align-items-center justify-content-left col-6">
              <p>Name</p>
            </div>
            <div class="col-6 mb-3">
              <input 
                class="new-instance-input w-100" 
                type="text" 
                name="entityName"
                [(ngModel)]="selectedEntity!.name"
                placeholder=" "
              />
            </div>
            <ng-container *ngIf="entityName != 'Incomer'">
              <div class="label-div d-flex align-items-center justify-content-left col-6">
                <p>Base Voltage</p>
              </div>
              <div class="col-6">
                <lib-object-dropdown
                      [items]="baseVoltages"
                      [displayField]="'name'" 
                      [initialValue]="baseVoltageValue"
                      (valueChange)="onSelectBaseVoltage($event)"
                      [disabled]="false"
                      [isRequired]="true"
                      #dropdownVoltage
                ></lib-object-dropdown>
              </div>
            </ng-container>
            
          </div>
          <div class="section w-100 row" *ngIf="!isOpenedFromSubstation">
            <div class="label-div d-flex align-items-center justify-content-left col-6">
              <p>Equipment Container</p>
            </div>
            <div class="col-6 mb-3">
              <lib-object-dropdown
                    *ngIf="!isEdit"
                    [items]="substationTemplateOptions"
                    [displayField]="'className'" 
                    (valueChange)="onSelectSubstationTemplate($event)"
                    [disabled]="false"
                    [isRequired]="true"
                    #substationTemplateDropdown
                ></lib-object-dropdown>
                <input
                *ngIf="isEdit"
                class="new-instance-input w-100 disabled"
                type="text"
                [value]="selectedEntity.parentClass"
                disabled/>
            </div>
            <div class="label-div d-flex align-items-center justify-content-left col-6">
              <p>Equipment Container Instance</p>
            </div>
            <div class="col-6">
              <lib-object-dropdown
                  *ngIf="!isEdit"
                  [items]="substationOptions"
                  [displayField]="'name'" 
                  (valueChange)="onSelectSubstationTemplateInstance($event)"
                  [disabled]="false"
                  [isRequired]="true"
                  [isSearchEnabled]="true"
                  [maxDisplayItemSize]="10"
                  (searchTextChange)="onSearchTextChange($event)"
                  #substationTemplateInstanceDropdown
                ></lib-object-dropdown>
                <input
                *ngIf="isEdit"
                class="new-instance-input w-100 disabled"
                type="text"
                [value]="selectedEntity.parentName"
                disabled/>
            </div>
          </div>
          <div class="section w-100 row">
            <div class="label-div d-flex align-items-center justify-content-left col-6">
              <p>Source</p>
            </div>
            <div class="col-6 mb-3">
              <lib-object-dropdown *ngIf="!isEdit && (selectedEquipmentType.value == 'Busbar' || selectedEquipmentType.value == 'Junction')"
                class="col-6"
                    (multiValueChange)="onSelectMultiSourceEquipment($event!)"
                    [items]="sourcesMultiSelect"
                    [displayField]="'name'" 
                    [isMultiSelect]="true"
                    [trackByField]="'id'">
              </lib-object-dropdown>
              <lib-object-dropdown
                  *ngIf="!isEdit && selectedEquipmentType.value != 'Busbar' && selectedEquipmentType.value != 'Junction'"
                  [items]="sourcesMultiSelect"
                  [displayField]="'name'" 
                  (valueChange)="onSelectSourceEquipment($event)"
                  [isRequired]="true"
                  #sourceEquipmentDropdown>
                </lib-object-dropdown>
            <input 
              *ngIf="isEdit"
              class="new-instance-input w-100" 
              type="text"
              [value]="sourcesDisplay"
              disabled/>
            </div>
            <div class="label-div d-flex align-items-center justify-content-left col-6">
              <p>Destination</p>
            </div>
            <div class="col-6">
              <lib-object-dropdown *ngIf="!isEdit && (selectedEquipmentType.value == 'Busbar' || selectedEquipmentType.value == 'Junction')"
                    class="col-6"
                    (multiValueChange)="onSelectMultiDestinationEquipment($event!)"
                    [items]="destinationsMultiSelect"
                    [displayField]="'name'" 
                    [isMultiSelect]="true"
                    [trackByField]="'id'"
                ></lib-object-dropdown>
                <lib-object-dropdown
                  *ngIf="!isEdit && selectedEquipmentType.value != 'Busbar' && selectedEquipmentType.value != 'Junction'"
                  [items]="destinationsMultiSelect"
                  [displayField]="'name'" 
                  (valueChange)="onSelectDestinationEquipment($event)"
                  [isRequired]="true"
                  #destinationEquipmentDropdown>
                </lib-object-dropdown>
              <input
                *ngIf="isEdit"
                class="new-instance-input w-100" 
                type="text"
                [value]="destinationsDisplay"
                disabled
              />
            </div>
          </div>
        </div>         
      <div class="modal-footer border-0">
        <button type="button" class="btn cancel-modal-btn" data-bs-dismiss="modal" #closeEditModal>Cancel</button>
        <button type="submit" class="btn save-modal-btn">Save</button>
      </div>
    </form>
  </div>
</div>